import { render, staticRenderFns } from "./buildingProperties.vue?vue&type=template&id=d3b20ee4&scoped=true&"
import script from "./buildingProperties.vue?vue&type=script&lang=js&"
export * from "./buildingProperties.vue?vue&type=script&lang=js&"
import style0 from "./buildingProperties.vue?vue&type=style&index=0&id=d3b20ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b20ee4",
  null
  
)

export default component.exports